import React from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface PrivacyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}
export function PrivacyModal({
  isOpen,
  onClose,
  title
}: PrivacyModalProps) {
  return <AnimatePresence data-id="element-158">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 z-[100] backdrop-blur-sm" data-id="element-159" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg bg-white rounded-xl shadow-2xl z-[101] overflow-hidden" data-id="element-160">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-161">
              <h2 className="text-xl font-bold text-forest" data-id="element-162">{title}</h2>
              <button onClick={onClose} className="p-2 text-gray-400 hover:text-forest hover:bg-gray-100 rounded-full transition-colors" data-id="element-163">
                <XIcon className="w-5 h-5" data-id="element-164" />
              </button>
            </div>
            <div className="p-6 max-h-[60vh] overflow-y-auto text-gray-600 space-y-4" data-id="element-165">
              <p data-id="element-166">
                This is a placeholder for the {title} document. In a production
                environment, this would contain the full legal text regarding
                your privacy policy or terms of service.
              </p>
              <p data-id="element-167">
                M&J The Green Mountain Landscaping respects your privacy and is
                committed to protecting your personal data. We collect
                information necessary to provide you with our landscaping
                services, including your name, address, and contact details.
              </p>
              <p data-id="element-168">
                We do not sell your personal information to third parties. For
                any questions regarding our policies, please contact us at
                360-623-4531.
              </p>
            </div>
            <div className="p-6 border-t border-gray-100 bg-gray-50 flex justify-end" data-id="element-169">
              <button onClick={onClose} className="px-6 py-2 bg-forest text-white rounded-lg font-medium hover:bg-forest-light transition-colors" data-id="element-170">
                Close
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}